export class DatePickerFormatter {

    public static mapDateFormat(format: string): string {
        var result = format;
        var words = [];

        var wordReplacer = {
            // dddd: function () {
            //     return "DD";
            // },
            // ddd: function () {
            //     return "D";
            // },
            // MMMM: function () {
            //     return "MM";
            // },
            // MMM: function () {
            //     return "M";
            // },
            // yyyy: function () {
            //     return "yyyy";
            // },
            // yyy: function () {
            //     return "yyyy";
            // },
            // dd: function () {
            //     return "dd";
            // },
            // d: function () {
            //     return "d";
            // },
            // MM: function () {
            //     return "mm";
            // },
            // M: function () {
            //     return "m";
            // },
            // yy: function () {
            //     return "yy";
            // },
            // y: function () {
            //     return "yy";
            // }
            dddd: function () {
                return "DD";
            },
            ddd: function () {
                return "D";
            },
            dd: function () {
                return "dd";
            },
            d: function () {
                return "d";
            },
            MMMM: function () {
                return "XXXX";
            },
            XXXX: function () {
                return "MM";
            },
            MMM: function () {
                return "XXX";
            },
            XXX: function () {
                return "M";
            },
            MM: function () {
                return "mm";
            },
            M: function () {
                return "m";
            },
            yyyy: function () {
                return "yyyy";
            },
            yyy: function () {
                return "yyyy";
            },
            yy: function () {
                return "yy";
            },
            y: function () {
                return "yy";
            }
        }

        words = result.match(/(dddd|ddd|MMMM|MMM|yyyy|yyy)/g);

        words.forEach(function (f) {
            if (typeof (wordReplacer[f]) === "function") {
                result = result.replace(f, wordReplacer[f]());
            }
        })

        words = result.match(/(dd|d|MM|M|yy|y)/g);
        words.forEach(function (f) {
            if (typeof (wordReplacer[f]) === "function") {
                result = result.replace(f, wordReplacer[f]());
            }
        })

        words = result.match(/(XXXX|XX)/g);
        if (words !== null) {
            words.forEach(function (f) {
                if (typeof (wordReplacer[f]) === "function") {
                    result = result.replace(f, wordReplacer[f]());
                }
            })
        }

        return result
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/common/date-picker-formatter.ts